<template>
<a-select
    show-search
    :filter-option="filterOption"
    :show-arrow='showArrow'
    label-in-value
    :value="selected"
    :placeholder="placeholder"
    :not-found-content="loading ? undefined : '请输入运营商名称进行搜索'"
    @search="getOperatorList"
    @change="handleChange"
    :disabled="disabled"
    :allow-clear='allowClear'
    @focus="handleFocus"
    :getPopupContainer="getPopupContainer()"
>
    <a-spin v-if="loading" slot="notFoundContent" size="small" />
    <a-select-option v-for="item of operatorList" :key="item.id">{{item.username}}</a-select-option>
</a-select>
</template>

<script>
import Core from '../../core';

export default {
    name: 'SelectOperator',
    model: {
        prop: 'value',
        event: 'update'
    },
    props: {
        value: {},
        disabled: {},

        target: { type: String, default: 'all' }, // all:所有运营商 | main:所有一级运营商 | sub:所有子运营商

        allowClear: { type: Boolean, default: true, },
        placeholder: { type: String, default: '请选择运营商', },
        stopSlip: { type: Boolean, default: false }, // 是否禁止跟随页面滑动

        showArrow: { type: Boolean, default: false }, // 是否显示下拉箭头
    },
    data() {
        return {
            loading: false,
            operatorList: [],
            selected: undefined,

            flagAdmin: Core.Util.auth('ADMIN'),
        };
    },
    watch: {
        value: {
            immediate: true,
            handler(n) {
                if (n) {
                    console.log('watch value:', n)
                    this.getOperatorDetail()
                } else {
                    this.selected = undefined
                }
            }
        }
    },
    computed: {
        funcName() {
            let funcName = 'listAll'
            switch (this.target) {
                case 'all': funcName = 'listAll'; break;
                case 'main': funcName = 'subList'; break;
                case 'sub':
                    funcName = this.flagAdmin ? 'listAll' : 'subList';
                    break; // TODO
            }
            console.log('funcName:', funcName)
            return funcName
        }
    },
    methods: {
        getOperatorDetail() {
            Core.Api.Operator[this.flagAdmin ? 'detail' : 'detailById'](this.value).then(res => {
                this.selected = {key: res.operator.id, label: res.operator.username}
                console.log('this.selected:', this.selected)
            }).catch(() => {
            })
        },
        getOperatorList(username) {
            if (!username) { this.loading = false; return this.operatorList = [] }
            Core.Api.Operator[this.funcName]({username}).then(res => {
                this.operatorList = res.operator_list || res.list
            }).finally(() => {
                this.loading = false
            })
        },


        filterOption(inputValue, option) {
            let username = option.componentOptions.children[0].text || ''
            return username.includes(inputValue)
        },
        // 聚焦
        handleFocus() {
            if (this.loading) { return }
            this.loading = true

            this.getOperatorList('')
        },
        // 搜索
        handleSearch(value) {
            if (this.loading) { return }
            this.loading = true
            if (!value) { return this.loading = false }

            this.getOperatorList(value)
        },
        // 选择
        handleChange(value = {}) {
            console.log('handleChange value:', value)
            this.selected = value
            this.loading = false
            this.operatorList = []

            this.$emit('update', value.key)
            this.$emit('change', value.key)
        },
        getPopupContainer() {
            if (this.stopSlip) {
                return triggerNode => triggerNode.parentNode || document.body;
            } else {
                return 
            }
        }
    },
};
</script>
